import React from 'react';
import { Typography } from '@mui/material';

import { CameraInsightsIcon } from 'components/Icons/CameraInsightsIcon';

import styles from './OutOfRangeButton.module.scss';

interface Props {
  day?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const OutOfRangeButton: React.FC<Props> = ({ day, onClick }) => {
  const dayLabel = day === 'Yesterday' ? 'yesterday' : day;
  const ctaText = dayLabel ? `View ${dayLabel}'s insights` : `View previous day's insights`;

  return (
    <button
      className={styles.button}
      data-testid="out-of-range-button"
      disabled={!onClick}
      onClick={onClick}
      type="button"
    >
      <CameraInsightsIcon className={styles.icon} />
      <Typography className={styles.text} component="span" variant="caption1">
        Not enough data for insights.
      </Typography>
      <Typography className={styles.cta} component="span" variant="callout1">
        {ctaText}
      </Typography>
    </button>
  );
};

export default OutOfRangeButton;
